import {GetterTree} from "vuex";
import {PortalSubtopicAsideWidgetState, IPortalSubtopicRelatedPagesWidgetModel, IPortalSubtopicContactWidgetModel} from "@/apps/PortalSubtopicAsideWidget/models/PortalSubtopicAside-widget-state";

export default <GetterTree<PortalSubtopicAsideWidgetState, PortalSubtopicAsideWidgetState>>{
    getRelatedPages(state): IPortalSubtopicRelatedPagesWidgetModel[] {
        return state.relatedPages;
    },
    getContactInformation(state): IPortalSubtopicContactWidgetModel[] {
        return state.contactInformation;
    },
    getSelectedFaculty(state): string {
        console.log("Getter: ", state.selectedFaculty)
        return state.selectedFaculty;
    }
}